<div class="flex flex-col h-full w-full overflow-hidden relative bg-gray-50">

  <div id='pdf-div'
       class="flex-1 w-full"
       [class.invisible]="!pdfPreview()?.complete">
  </div>

  @if (!pdfPreview()?.complete && !pdfPreview()?.error) {
    <div class="absolute inset-0 flex flex-col items-center justify-center bg-gray-50/80 z-10 backdrop-blur-[2px]">

      <div class="size-10 border-4 border-gray-200 border-t-[#5d6ff6] rounded-full animate-spin mb-4"></div>

      <span class="text-sm font-medium text-gray-700 animate-pulse">
        @switch (pdfPreview()?.event?.type) {
          @case ('start') { Préparation... }
          @case ('download') { Téléchargement ({{pdfPreview()?.event?.progress}}%) }
          @case ('rendering') { Génération de l'aperçu... }
          @default { Chargement de la visionneuse... }
        }
      </span>
    </div>
  }

  @if (pdfPreview()?.error) {
    <div class="absolute inset-0 flex flex-col items-center justify-center p-6 text-center bg-white z-20">
      <svg class="size-12 text-red-500 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <h2 class="text-lg font-bold text-gray-900">{{ pdfPreview()?.error }}</h2>
    </div>
  }

  <div class="p-2 bg-white border-t border-gray-100 shrink-0 text-left">
    <span class="!text-xs font-semibold text-gray-700">
      Si la prévisualisation ne s'affiche pas correctement cliquer
      <a target="_blank"
         class="text-red-500 hover:underline font-bold inline"
         [href]="pdfUrl()">ici</a>
    </span>
  </div>
</div>